export const COST_CENTER = 'CostCenter';
//# sourceMappingURL=cost-center.js.map